import { defineMessages } from 'react-intl';

/** The copy of the song page (design song-page a to f). */
export const songPageMessages = defineMessages({
  // Header (b1)
  eyebrowUnreleased: { id: 'app.sml.catalog.songPage.eyebrow.unreleased', defaultMessage: 'Unreleased' },
  eyebrowOut: { id: 'app.sml.catalog.songPage.eyebrow.out', defaultMessage: 'Out {date}' },
  eyebrowIn: {
    id: 'app.sml.catalog.songPage.eyebrow.in',
    defaultMessage: '{days, plural, one {in # day} other {in # days}}',
  },
  eyebrowNoDate: { id: 'app.sml.catalog.songPage.eyebrow.noDate', defaultMessage: 'No release date yet' },
  addedByYou: { id: 'app.sml.catalog.songPage.addedByYou', defaultMessage: 'Added by you' },
  featured: { id: 'app.sml.catalog.songPage.featured', defaultMessage: 'Featured' },
  yours: { id: 'app.sml.catalog.songPage.yours', defaultMessage: 'Yours' },
  chipMasterReady: { id: 'app.sml.catalog.songPage.chip.masterReady', defaultMessage: 'Master ready' },
  chipMasterReading: { id: 'app.sml.catalog.songPage.chip.masterReading', defaultMessage: 'Reading the song' },
  chipMasterFailed: { id: 'app.sml.catalog.songPage.chip.masterFailed', defaultMessage: 'Master failed' },
  chipNoMaster: { id: 'app.sml.catalog.songPage.chip.noMaster', defaultMessage: 'No master' },
  chipLyricsSynced: { id: 'app.sml.catalog.songPage.chip.lyricsSynced', defaultMessage: 'Lyrics synced' },
  chipLyricsSyncing: { id: 'app.sml.catalog.songPage.chip.lyricsSyncing', defaultMessage: 'Syncing lyrics' },
  chipLyricsFailed: { id: 'app.sml.catalog.songPage.chip.lyricsFailed', defaultMessage: 'Lyrics not synced' },
  chipToCheck: {
    id: 'app.sml.catalog.songPage.chip.toCheck',
    defaultMessage: '{count, plural, one {# time to check} other {# times to check}}',
  },
  chipPresave: { id: 'app.sml.catalog.songPage.chip.presave', defaultMessage: 'Pre-save live' },
  chipSmartLink: { id: 'app.sml.catalog.songPage.chip.smartLink', defaultMessage: 'SmartLink live' },
  chipKit: { id: 'app.sml.catalog.songPage.chip.kit', defaultMessage: 'Kit {ready} of {total}' },
  makeInStudio: { id: 'app.sml.catalog.songPage.makeInStudio', defaultMessage: 'Make in Studio' },
  openInReleases: { id: 'app.sml.catalog.songPage.openInReleases', defaultMessage: 'Open in Releases' },
  menu: { id: 'app.sml.catalog.songPage.menu', defaultMessage: 'Song actions' },
  menuCopyLink: { id: 'app.sml.catalog.songPage.menu.copyLink', defaultMessage: 'Copy the link of the page' },
  menuLinkCopied: { id: 'app.sml.catalog.songPage.menu.linkCopied', defaultMessage: 'The link is copied.' },
  menuEditLyrics: { id: 'app.sml.catalog.songPage.menu.editLyrics', defaultMessage: 'Edit the lyrics' },
  menuRemove: { id: 'app.sml.catalog.songPage.menu.remove', defaultMessage: 'Remove from the catalog' },
  menuUnclaim: { id: 'app.sml.catalog.songPage.menu.unclaim', defaultMessage: 'Un-claim this release' },
  // Sections and the anchor nav
  sectionDetails: { id: 'app.sml.catalog.songPage.section.details', defaultMessage: 'Details' },
  sectionFiles: { id: 'app.sml.catalog.songPage.section.files', defaultMessage: 'Song files' },
  sectionLyrics: { id: 'app.sml.catalog.songPage.section.lyrics', defaultMessage: 'Lyrics' },
  sectionRelease: { id: 'app.sml.catalog.songPage.section.release', defaultMessage: 'Links and release' },
  sectionNav: { id: 'app.sml.catalog.songPage.section.nav', defaultMessage: 'Sections of the song page' },
  navReady: { id: 'app.sml.catalog.songPage.nav.ready', defaultMessage: 'Ready' },
  navSynced: { id: 'app.sml.catalog.songPage.nav.synced', defaultMessage: 'Synced' },
  navNone: { id: 'app.sml.catalog.songPage.nav.none', defaultMessage: 'None' },
  // Details (b1, b2, b3)
  detailsTitle: { id: 'app.sml.catalog.songPage.details.title', defaultMessage: 'Song details' },
  allSaved: { id: 'app.sml.catalog.songPage.details.allSaved', defaultMessage: 'All changes saved' },
  unsavedCount: {
    id: 'app.sml.catalog.songPage.details.unsavedCount',
    defaultMessage: '{count, plural, one {# unsaved change} other {# unsaved changes}}',
  },
  fieldTitle: { id: 'app.sml.catalog.songPage.field.title', defaultMessage: 'Title' },
  fieldArtist: { id: 'app.sml.catalog.songPage.field.artist', defaultMessage: 'Artist' },
  fieldType: { id: 'app.sml.catalog.songPage.field.type', defaultMessage: 'Type' },
  fieldTypeNone: { id: 'app.sml.catalog.songPage.field.typeNone', defaultMessage: 'Single, EP or Album' },
  fieldReleaseDate: { id: 'app.sml.catalog.songPage.field.releaseDate', defaultMessage: 'Release date' },
  fieldReleased: { id: 'app.sml.catalog.songPage.field.released', defaultMessage: 'Released' },
  fieldReleaseDateHelp: {
    id: 'app.sml.catalog.songPage.field.releaseDateHelp',
    defaultMessage: 'On this day MUSIC24 looks for the song on the services and links it.',
  },
  fieldIsrcHelp: {
    id: 'app.sml.catalog.songPage.field.isrcHelp',
    defaultMessage: 'With the ISRC, MUSIC24 finds the song on release day at once. You find it at your distributor.',
  },
  fieldCover: { id: 'app.sml.catalog.songPage.field.cover', defaultMessage: 'Cover art' },
  coverReplace: { id: 'app.sml.catalog.songPage.cover.replace', defaultMessage: 'Replace' },
  coverAdd: { id: 'app.sml.catalog.songPage.cover.add', defaultMessage: 'Add the cover art' },
  coverRemove: { id: 'app.sml.catalog.songPage.cover.remove', defaultMessage: 'Remove' },
  coverUploading: { id: 'app.sml.catalog.songPage.cover.uploading', defaultMessage: 'Uploading the cover art' },
  coverNone: { id: 'app.sml.catalog.songPage.cover.none', defaultMessage: 'No cover art yet' },
  coverFailed: {
    id: 'app.sml.catalog.songPage.cover.failed',
    defaultMessage: 'The cover art did not upload. Try again.',
  },
  titleRequired: { id: 'app.sml.catalog.songPage.error.titleRequired', defaultMessage: 'Add a title.' },
  tooLong: { id: 'app.sml.catalog.songPage.error.tooLong', defaultMessage: 'Use {max} characters or fewer.' },
  fromServices: { id: 'app.sml.catalog.songPage.fromServices', defaultMessage: 'From the services' },
  fromServicesHelp: {
    id: 'app.sml.catalog.songPage.fromServicesHelp',
    defaultMessage:
      'A claimed release keeps the details of the services. To fix a detail, fix it at your distributor; MUSIC24 reads it again.',
  },
  ownership: { id: 'app.sml.catalog.songPage.ownership', defaultMessage: 'Whose release is this?' },
  ownershipMine: { id: 'app.sml.catalog.songPage.ownership.mine', defaultMessage: 'My own release' },
  ownershipFeatured: { id: 'app.sml.catalog.songPage.ownership.featured', defaultMessage: 'I am a featured artist' },
  ownershipHelp: {
    id: 'app.sml.catalog.songPage.ownership.help',
    defaultMessage: 'A featured release counts in your numbers but not as your own song in Home and the digests.',
  },
  aboutTitle: { id: 'app.sml.catalog.songPage.about.title', defaultMessage: 'About this song' },
  aboutInCatalog: { id: 'app.sml.catalog.songPage.about.inCatalog', defaultMessage: 'In the catalog' },
  aboutUnreleased: { id: 'app.sml.catalog.songPage.about.unreleased', defaultMessage: 'Unreleased, added by you' },
  aboutClaimed: { id: 'app.sml.catalog.songPage.about.claimed', defaultMessage: 'Released, claimed from the services' },
  aboutAdded: { id: 'app.sml.catalog.songPage.about.added', defaultMessage: 'Added' },
  aboutReleaseDay: { id: 'app.sml.catalog.songPage.about.releaseDay', defaultMessage: 'Release day' },
  aboutReleaseDayValue: {
    id: 'app.sml.catalog.songPage.about.releaseDayValue',
    defaultMessage: 'MUSIC24 links it on {date}',
  },
  aboutNote: {
    id: 'app.sml.catalog.songPage.about.note',
    defaultMessage:
      'Every reel, kit asset and SmartLink of {title} reads these details. A new title shows on new assets only.',
  },
  // Song files (c1 to c6)
  masterTitle: { id: 'app.sml.catalog.songPage.master.title', defaultMessage: 'Master' },
  masterUsedBy: { id: 'app.sml.catalog.songPage.master.usedBy', defaultMessage: 'Used by every reel and kit asset' },
  masterUploaded: { id: 'app.sml.catalog.songPage.master.uploaded', defaultMessage: 'Uploaded {date}' },
  factLength: { id: 'app.sml.catalog.songPage.fact.length', defaultMessage: 'Length' },
  factTempo: { id: 'app.sml.catalog.songPage.fact.tempo', defaultMessage: 'Tempo' },
  factHook: { id: 'app.sml.catalog.songPage.fact.hook', defaultMessage: 'Hook' },
  factBeat: { id: 'app.sml.catalog.songPage.fact.beat', defaultMessage: 'Beat' },
  beatDetected: { id: 'app.sml.catalog.songPage.beat.detected', defaultMessage: 'Detected' },
  beatFallback: { id: 'app.sml.catalog.songPage.beat.fallback', defaultMessage: 'Fixed 120 BPM' },
  hookHelp: {
    id: 'app.sml.catalog.songPage.hookHelp',
    defaultMessage:
      'The hook is where reels and short videos start by default. MUSIC24 reads it from the song; you pick another start in the Studio.',
  },
  keptTitle: { id: 'app.sml.catalog.songPage.kept.title', defaultMessage: 'Kept from this master' },
  keptPlayCopy: { id: 'app.sml.catalog.songPage.kept.playCopy', defaultMessage: 'Play copy' },
  keptPlayCopyNote: {
    id: 'app.sml.catalog.songPage.kept.playCopyNote',
    defaultMessage: 'AAC 320 kbps · for the player',
  },
  keptVocalStem: { id: 'app.sml.catalog.songPage.kept.vocalStem', defaultMessage: 'Vocal stem' },
  keptVocalStemNote: {
    id: 'app.sml.catalog.songPage.kept.vocalStemNote',
    defaultMessage: 'From the lyric sync · re-syncs use it',
  },
  keptAnalysis: { id: 'app.sml.catalog.songPage.kept.analysis', defaultMessage: 'Song analysis' },
  keptAnalysisNote: { id: 'app.sml.catalog.songPage.kept.analysisNote', defaultMessage: 'Beats, sections, hook' },
  keptNothing: {
    id: 'app.sml.catalog.songPage.kept.nothing',
    defaultMessage: 'MUSIC24 keeps nothing from this master yet.',
  },
  replaceEdits: {
    id: 'app.sml.catalog.songPage.replaceEdits',
    defaultMessage:
      'The lyrics sync again to the new master. {count, plural, one {The # time you set by hand goes.} other {The # times you set by hand go.}}',
  },
  uploadKeepOpen: {
    id: 'app.sml.catalog.songPage.uploadKeepOpen',
    defaultMessage: 'Keep this tab open until the upload ends. You can use the other parts of this page.',
  },
  // Lyrics (d1 to d8)
  viewTimes: { id: 'app.sml.catalog.songPage.lyrics.times', defaultMessage: 'Times' },
  viewText: { id: 'app.sml.catalog.songPage.lyrics.text', defaultMessage: 'Text' },
  lyricsView: { id: 'app.sml.catalog.songPage.lyrics.view', defaultMessage: 'Lyrics view' },
  lyricsHelp: {
    id: 'app.sml.catalog.songPage.lyrics.help',
    defaultMessage: 'One line per lyric line. A blank line marks a new part. Leave out labels such as [Chorus].',
  },
  lyricsCount: { id: 'app.sml.catalog.songPage.lyrics.count', defaultMessage: '{length} / {max}' },
  lyricsEmptyTitle: { id: 'app.sml.catalog.songPage.lyrics.emptyTitle', defaultMessage: 'Add the lyrics of {title}' },
  lyricsEmptyBody: {
    id: 'app.sml.catalog.songPage.lyrics.emptyBody',
    defaultMessage: 'We sync them to the master. Lyric videos and lyric moments need them.',
  },
  timesMakeTitle: { id: 'app.sml.catalog.songPage.timesMake.title', defaultMessage: 'The times make' },
  timesMakeLyricVideo: {
    id: 'app.sml.catalog.songPage.timesMake.lyricVideo',
    defaultMessage: 'Lyric video · 16:9, the whole song',
  },
  timesMakeMoment: {
    id: 'app.sml.catalog.songPage.timesMake.moment',
    defaultMessage: 'Lyric moment · 9:16, the chorus',
  },
  timesMakeCaptions: { id: 'app.sml.catalog.songPage.timesMake.captions', defaultMessage: 'Music video captions' },
  timesMakeCard: { id: 'app.sml.catalog.songPage.timesMake.card', defaultMessage: 'Lyric card · one line' },
  timesMakeNote: {
    id: 'app.sml.catalog.songPage.timesMake.note',
    defaultMessage: 'A change of the times makes no asset again. Make a new revision in the Studio.',
  },
  gateLyricVideo: {
    id: 'app.sml.catalog.songPage.gate.lyricVideoPro',
    defaultMessage: 'Full-song videos need the Pro plan. The lyric moment (9:16) works on every plan.',
  },
  upgrade: { id: 'app.sml.catalog.songPage.upgrade', defaultMessage: 'Upgrade' },
  // Links and release (e1 to e4)
  smartLinkTitle: { id: 'app.sml.catalog.songPage.smartLink.title', defaultMessage: 'SmartLink' },
  smartLinkLive: { id: 'app.sml.catalog.songPage.smartLink.live', defaultMessage: 'Live' },
  smartLinkDraft: { id: 'app.sml.catalog.songPage.smartLink.draft', defaultMessage: 'Draft' },
  smartLinkNone: { id: 'app.sml.catalog.songPage.smartLink.none', defaultMessage: 'None' },
  smartLinkOpen: { id: 'app.sml.catalog.songPage.smartLink.open', defaultMessage: 'Open the page' },
  smartLinkEdit: { id: 'app.sml.catalog.songPage.smartLink.edit', defaultMessage: 'Edit' },
  smartLinkMake: { id: 'app.sml.catalog.songPage.smartLink.make', defaultMessage: 'Make a SmartLink' },
  smartLinkPitch: {
    id: 'app.sml.catalog.songPage.smartLink.pitch',
    defaultMessage: 'One page with every service of {title}. Fans pick their app.',
  },
  smartLinkPresaveHelp: {
    id: 'app.sml.catalog.songPage.smartLink.presaveHelp',
    defaultMessage: 'On release day the page turns into the SmartLink of the song with the links of the services.',
  },
  pagesLimit: {
    id: 'app.sml.catalog.songPage.smartLink.pagesLimit',
    defaultMessage: 'You use {used} of {limit} published pages on Free.',
  },
  kitTitle: { id: 'app.sml.catalog.songPage.kit.title', defaultMessage: 'Release Kit' },
  kitReady: {
    id: 'app.sml.catalog.songPage.kit.ready',
    defaultMessage: '{ready} of {total} assets ready',
  },
  kitWorking: { id: 'app.sml.catalog.songPage.kit.working', defaultMessage: '{count} working' },
  kitNothing: { id: 'app.sml.catalog.songPage.kit.nothing', defaultMessage: 'Nothing made from this song yet.' },
  removeTitle: { id: 'app.sml.catalog.songPage.remove.title', defaultMessage: 'Remove {title} from the catalog' },
  removeUnclaimTitle: { id: 'app.sml.catalog.songPage.remove.unclaimTitle', defaultMessage: 'Un-claim {title}' },
  removeBody: {
    id: 'app.sml.catalog.songPage.remove.body',
    defaultMessage: 'The song, its lyrics and its Release Kit go. The pre-save page and the scheduled posts stay.',
  },
  removeButton: { id: 'app.sml.catalog.songPage.remove.button', defaultMessage: 'Remove' },
  unclaimButton: { id: 'app.sml.catalog.songPage.remove.unclaimButton', defaultMessage: 'Un-claim' },
  removeDialogTitle: {
    id: 'app.sml.catalog.songPage.remove.dialogTitle',
    defaultMessage: 'Remove {title} from the catalog?',
  },
  removeDialogLead: {
    id: 'app.sml.catalog.songPage.remove.dialogLead',
    defaultMessage: 'This goes with it and does not come back:',
  },
  removeGoesSong: {
    id: 'app.sml.catalog.songPage.remove.goesSong',
    defaultMessage: 'The song in the catalog, with its master, lyrics and times',
  },
  removeGoesKit: {
    id: 'app.sml.catalog.songPage.remove.goesKit',
    defaultMessage: 'The Release Kit and the kit zip (assets in progress give their credits back)',
  },
  removeGoesStem: {
    id: 'app.sml.catalog.songPage.remove.goesStem',
    defaultMessage: 'The stored vocal stem and alignments of the master',
  },
  removeStays: {
    id: 'app.sml.catalog.songPage.remove.stays',
    defaultMessage: 'The pre-save page, the AI reels and the posts already scheduled stay; they keep their files.',
  },
  removeConfirm: { id: 'app.sml.catalog.songPage.remove.confirm', defaultMessage: 'Remove {title}' },
  unclaimDialogTitle: { id: 'app.sml.catalog.songPage.remove.unclaimDialogTitle', defaultMessage: 'Un-claim {title}?' },
  unclaimDialogBody: {
    id: 'app.sml.catalog.songPage.remove.unclaimDialogBody',
    defaultMessage: '{title} goes back to the suggestions. The pages you built from it stay online.',
  },
  removed: { id: 'app.sml.catalog.songPage.remove.done', defaultMessage: '{title} is no longer in your catalog.' },
  ownerOnlyTitle: {
    id: 'app.sml.catalog.songPage.ownerOnly.title',
    defaultMessage: 'Only the owner can remove {title}',
  },
  ownerOnlyBody: {
    id: 'app.sml.catalog.songPage.ownerOnly.body',
    defaultMessage: 'The song has a master. Ask {owner} to remove it.',
  },
  ownerOnlyBodyNoEmail: {
    id: 'app.sml.catalog.songPage.ownerOnly.bodyNoEmail',
    defaultMessage: 'The song has a master. Ask the owner of this workspace to remove it.',
  },
  // Page states (f1 to f9)
  notFoundTitle: {
    id: 'app.sml.catalog.songPage.notFound.title',
    defaultMessage: 'We could not find this song in your catalog.',
  },
  notFoundBody: {
    id: 'app.sml.catalog.songPage.notFound.body',
    defaultMessage: 'Someone removed it, or it belongs to another artist of this workspace.',
  },
  openCatalog: { id: 'app.sml.catalog.songPage.openCatalog', defaultMessage: 'Open the Catalog' },
  memberNote: {
    id: 'app.sml.catalog.songPage.memberNote',
    defaultMessage: 'You edit this song as a member of {workspace}. Your changes show for the whole team.',
  },
  dismiss: { id: 'app.sml.catalog.songPage.dismiss', defaultMessage: 'Dismiss' },
  changedElsewhere: {
    id: 'app.sml.catalog.songPage.changedElsewhere',
    defaultMessage: '{title} changed on another device. We show the new version.',
  },
  changedWhileEditing: {
    id: 'app.sml.catalog.songPage.changedWhileEditing',
    defaultMessage:
      'Someone saved {title} while you edited. Save yours to replace their change, or discard yours to see it.',
  },
  discardMine: { id: 'app.sml.catalog.songPage.discardMine', defaultMessage: 'Discard mine' },
  // Save bar (b3, d2, e3, f5)
  saveBarChanges: {
    id: 'app.sml.catalog.songPage.saveBar.changes',
    defaultMessage: '{count, plural, one {# unsaved change} other {# unsaved changes}}',
  },
  saveBarLyrics: {
    id: 'app.sml.catalog.songPage.saveBar.lyrics',
    defaultMessage: '{count, plural, =0 {the lyrics sync again} one {# line syncs again} other {# lines sync again}}',
  },
  saveBarFixFirst: {
    id: 'app.sml.catalog.songPage.saveBar.fixFirst',
    defaultMessage: '{count, plural, one {fix # field to save} other {fix # fields to save}}',
  },
  saveBarSaving: {
    id: 'app.sml.catalog.songPage.saveBar.saving',
    defaultMessage: '{count, plural, one {Saving # change…} other {Saving # changes…}}',
  },
  saveBarFailed: {
    id: 'app.sml.catalog.songPage.saveBar.failed',
    defaultMessage: 'We could not save. Your changes are still here.',
  },
  saveBarPartFailed: {
    id: 'app.sml.catalog.songPage.saveBar.partFailed',
    defaultMessage: 'Some changes are saved. The others did not save.',
  },
  saveBarSaved: { id: 'app.sml.catalog.songPage.saveBar.saved', defaultMessage: 'All changes saved' },
  discard: { id: 'app.sml.catalog.songPage.discard', defaultMessage: 'Discard' },
  save: { id: 'app.sml.catalog.songPage.save', defaultMessage: 'Save changes' },
  tryAgain: { id: 'app.sml.catalog.songPage.tryAgain', defaultMessage: 'Try again' },
  fieldTitleShort: { id: 'app.sml.catalog.songPage.changed.title', defaultMessage: 'Title' },
  changedArtist: { id: 'app.sml.catalog.songPage.changed.artist', defaultMessage: 'Artist' },
  changedType: { id: 'app.sml.catalog.songPage.changed.type', defaultMessage: 'Type' },
  changedDate: { id: 'app.sml.catalog.songPage.changed.date', defaultMessage: 'Release date' },
  changedCover: { id: 'app.sml.catalog.songPage.changed.cover', defaultMessage: 'Cover art' },
  changedIsrc: { id: 'app.sml.catalog.songPage.changed.isrc', defaultMessage: 'ISRC' },
  changedLyrics: { id: 'app.sml.catalog.songPage.changed.lyrics', defaultMessage: 'Lyrics' },
  changedOwnership: { id: 'app.sml.catalog.songPage.changed.ownership', defaultMessage: 'Ownership' },
  // Leave guard (f4)
  leaveTitle: { id: 'app.sml.catalog.songPage.leave.title', defaultMessage: 'Leave without saving?' },
  leaveBody: {
    id: 'app.sml.catalog.songPage.leave.body',
    defaultMessage: 'You changed {fields} of {title}. The changes go if you leave.',
  },
  leaveUploadTitle: { id: 'app.sml.catalog.songPage.leave.uploadTitle', defaultMessage: 'Stop the upload?' },
  leaveUploadBody: {
    id: 'app.sml.catalog.songPage.leave.uploadBody',
    defaultMessage: 'An upload of the master is running. It stops if you leave.',
  },
  leave: { id: 'app.sml.catalog.songPage.leave.leave', defaultMessage: 'Leave' },
  keepEditing: { id: 'app.sml.catalog.songPage.leave.keepEditing', defaultMessage: 'Keep editing' },
  stay: { id: 'app.sml.catalog.songPage.leave.stay', defaultMessage: 'Stay' },
  saveAndLeave: { id: 'app.sml.catalog.songPage.leave.saveAndLeave', defaultMessage: 'Save and leave' },
});
